import React from 'react'
import moment from 'moment'
import _ from 'moment-timezone'

import DelayCertificateFooterRemark from './DelayCertificateFooterRemark'
import DelayCertificateHelper from './DelayCertificateHelper'

import ScrollToTop from '../shared/ScrollToTop'

const DelayCertificateDetail = ({ delayCertificate }) => {
  if (!delayCertificate) {
    return null
  }
  
  return (
    <div className="d-Delay">
      <ScrollToTop />
      <h1 className="d-Delay-detailTitle">遅延証明書</h1>
      <div className="d-Delay-notice">
        <p className="d-Delay-noticeText">相鉄線は以下の通り遅延したことを証明いたします。</p>
        <dl className="d-Delay-noticeContent">
          <dt className="d-Delay-noticeContentName">遅延発生日</dt>
          <dd className="d-Delay-noticeContentDetail">{DelayCertificateHelper.formattedDate(delayCertificate.delay_date)}</dd>
          <dt className="d-Delay-noticeContentName">遅延時間帯</dt>
          <dd className="d-Delay-noticeContentDetail">{DelayCertificateHelper.delayTimeZoneHuman(delayCertificate.delay_time_zone)}</dd>
          <dt className="d-Delay-noticeContentName">最大遅延時間</dt>
          <dd className="d-Delay-noticeContentDetail -type-delaytime">{DelayCertificateHelper.delayTimeHuman(delayCertificate.delay_time)}</dd>
        </dl>
        <p className="d-Delay-noticeText">ご迷惑をおかけし、誠に申し訳ございませんでした。</p>
        <p className="d-Delay-noticeText">相模鉄道株式会社</p>
      </div>
      <DelayCertificateFooterRemark />
    </div>
  )
}

export default DelayCertificateDetail
